import React from 'react'

const AbonnementGroupBookGuide = () => {
  return (
    <div>AbonnementGroupBookGuide</div>
  )
}

export default AbonnementGroupBookGuide